import { darken } from "@commonlibs";
import { css } from "styled-components";

export const ScrollBarStyles = css(
    ({ theme }) => css`
        /* width */
        ::-webkit-scrollbar {
            width: 0.375rem;
            height: 0.375rem;
            cursor: pointer;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            border-radius: 100px;
            background: ${theme.palette.gray[100]};
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background-color: ${theme.palette.primary};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background-color: ${darken(theme.palette.primary, 0.1)};
        }
    `,
);
